export default __webpack_public_path__ + "static/media/logoBlack.48de2f65.png";